var _path, _path2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoundCheckboxChecked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.08531 11.7552L3.50098 8.17084L4.67346 6.99741L7.08531 9.4083L11.6577 4.83496L12.8311 6.0084L7.08531 11.7552Z",
    fill: "#ABABAC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C6.41775 0 4.87103 0.469193 3.55544 1.34824C2.23985 2.2273 1.21447 3.47673 0.608968 4.93853C0.00346704 6.40034 -0.154961 8.00888 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88744 15.5376 6.43929 15.8463C7.99113 16.155 9.59967 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C15.9977 5.87896 15.1541 3.84545 13.6543 2.34566C12.1545 0.845859 10.121 0.00227647 8 0ZM8 15.0521C6.60519 15.0523 5.24165 14.6388 4.08182 13.8641C2.92198 13.0893 2.01796 11.988 1.48406 10.6994C0.950158 9.4108 0.810367 7.99283 1.08237 6.6248C1.35436 5.25676 2.02592 4.00011 3.01214 3.01377C3.99835 2.02742 5.25492 1.35568 6.62291 1.0835C7.99091 0.811314 9.40888 0.950912 10.6975 1.48464C11.9862 2.01837 13.0876 2.92225 13.8626 4.08198C14.6375 5.24171 15.0511 6.60519 15.0511 8C15.0511 9.87016 14.3083 11.6637 12.986 12.9862C11.6636 14.3087 9.87016 15.0518 8 15.0521Z",
    fill: "#ABABAC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9013 9.28319C16.6092 4.92199 13.6476 0.812655 9.28642 0.104733C4.92523 -0.603189 0.815899 2.35838 0.107977 6.71958C-0.599945 11.0808 2.36162 15.1901 6.72281 15.898C11.084 16.6059 15.1933 13.6444 15.9013 9.28319Z",
    fill: "#FE5A1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.0902 11.9249L3.45117 8.28586L4.6425 7.09454L7.0902 9.54223L11.733 4.89941L12.9243 6.09074L7.0902 11.9249Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundCheckboxChecked);
export default __webpack_public_path__ + "static/media/round_checkbox_checked.c4be7c9933678ef226b1162be55dc26c.svg";
export { ForwardRef as ReactComponent };